import { Navigate } from 'react-router-dom';
import { homeFor, useMe } from '../auth/AuthContext';

/** /dashboard: sends the signed-in user to the console or portal that fits their role. */
export function Dashboard() {
  const me = useMe();
  return <Navigate to={homeFor(me)} replace />;
}
